var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { userSignup } from '@/api/authService';
import { useAuth, useConfigContext, useToast } from '@/hoc';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Button from './common/Button';
import Checkbox from './common/Checkbox';
import InputField from './common/InputField';
import { FormDropdown } from './form';
import VerifyEmailModal from './VerifyEmail';
import FileUploader from './FileUploader';
import axios from 'axios';
var SignupForm = function (_a) {
    var _b, _c, _d;
    var onSuccess = _a.onSuccess;
    var _e = useState(false), isLoading = _e[0], setIsLoading = _e[1];
    var _f = useState(false), openVerifyEmailModal = _f[0], setOpenVerifyEmailModal = _f[1];
    var _g = useState(null), signupData = _g[0], setSignupData = _g[1];
    var _h = useState(''), email = _h[0], setEmail = _h[1];
    var _j = useConfigContext(), config = _j.config, setConfig = _j.setConfig;
    var showToast = useToast().showToast;
    var login = useAuth().login;
    var _k = useState({}), file = _k[0], setFile = _k[1];
    var _l = useState({}), fileError = _l[0], setFileError = _l[1];
    var _m = useState(false), isFileAvliable = _m[0], setIsFileAvliable = _m[1];
    var defaultFields = (_b = config === null || config === void 0 ? void 0 : config.dynamicFields) === null || _b === void 0 ? void 0 : _b.filter(function (field) {
        return field.isDefault;
    }).reduce(function (acc, field) {
        acc[field.name] = field.defaultValue || '';
        return acc;
    }, {});
    var _o = useForm({
        defaultValues: __assign({}, defaultFields),
    }), register = _o.register, handleSubmit = _o.handleSubmit, errors = _o.formState.errors, watch = _o.watch, control = _o.control;
    var onEmailVerify = function () {
        var _a, _b, _c, _d, _e;
        console.log(signupData);
        if ((signupData === null || signupData === void 0 ? void 0 : signupData.user) || (signupData === null || signupData === void 0 ? void 0 : signupData.account_id))
            login({
                id: ((_a = signupData === null || signupData === void 0 ? void 0 : signupData.user) === null || _a === void 0 ? void 0 : _a.id) || (signupData === null || signupData === void 0 ? void 0 : signupData.account_id),
                access_token: ((_b = signupData === null || signupData === void 0 ? void 0 : signupData.user) === null || _b === void 0 ? void 0 : _b.access_token) || (signupData === null || signupData === void 0 ? void 0 : signupData.access) || '',
                refresh_token: ((_c = signupData === null || signupData === void 0 ? void 0 : signupData.user) === null || _c === void 0 ? void 0 : _c.refresh_token) || (signupData === null || signupData === void 0 ? void 0 : signupData.refresh) || '',
                name: (_d = signupData === null || signupData === void 0 ? void 0 : signupData.user) === null || _d === void 0 ? void 0 : _d.name,
                mobile: (_e = signupData === null || signupData === void 0 ? void 0 : signupData.user) === null || _e === void 0 ? void 0 : _e.mobile,
            });
    };
    var onSubmit = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
        var fieldArray, fileNameKeysArray_1, errorsObj_1, fileField, signupResponse, fileArray;
        var _b, _c;
        var rememberMe = _a.rememberMe, data = __rest(_a, ["rememberMe"]);
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (isFileAvliable) {
                        fieldArray = (config === null || config === void 0 ? void 0 : config.dynamicFields) || [];
                        fileNameKeysArray_1 = [];
                        errorsObj_1 = {};
                        fileField = fieldArray.filter(function (field) { return field.type === 'file' && field.required; });
                        fileField.forEach(function (field) {
                            fileNameKeysArray_1.push(field.name);
                        });
                        fileNameKeysArray_1.forEach(function (key) {
                            if (file[key] === null || file[key] === undefined) {
                                errorsObj_1[key] = "".concat(key, " is required");
                            }
                        });
                        setFileError(errorsObj_1);
                        if (Object.keys(errorsObj_1).length > 0) {
                            return [2 /*return*/, false];
                        }
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, userSignup(__assign(__assign({}, data), { user_type_id: config === null || config === void 0 ? void 0 : config.userTypeId, group_id: config === null || config === void 0 ? void 0 : config.groupId, user_role_id: config === null || config === void 0 ? void 0 : config.userRoleId, product_name: config === null || config === void 0 ? void 0 : config.productName }), config === null || config === void 0 ? void 0 : config.signupRoute)];
                case 1:
                    signupResponse = _d.sent();
                    if (signupResponse.status === 'success' || signupResponse.success) {
                        setSignupData(signupResponse === null || signupResponse === void 0 ? void 0 : signupResponse.data);
                        setEmail(watch('email'));
                        setOpenVerifyEmailModal(true);
                        showToast({
                            message: 'Signed up successfully',
                            status: 'success',
                        });
                        if (rememberMe) {
                            localStorage.setItem('rememberMe', JSON.stringify(data));
                        }
                        fileArray = Object.keys(file);
                        if (fileArray.length > 0) {
                            fileArray.forEach(function (key) { return __awaiter(void 0, void 0, void 0, function () {
                                var url, formData, response;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            url = '';
                                            formData = new FormData();
                                            formData.append(key, file[key]);
                                            formData.append('action', 'parse');
                                            (_a = config === null || config === void 0 ? void 0 : config.dynamicFields) === null || _a === void 0 ? void 0 : _a.forEach(function (field) {
                                                if (field.name === key) {
                                                    url = field.sideEffectUrl || '';
                                                }
                                            });
                                            return [4 /*yield*/, axios.patch("".concat(url).concat(signupResponse.candidate_profile_id, "/"), formData, {
                                                    headers: {
                                                        Authorization: "Bearer ".concat(signupResponse.access || ''),
                                                        'Content-Type': 'multipart/form-data',
                                                    },
                                                })];
                                        case 1:
                                            response = _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                    }
                    else if ((_b = signupResponse === null || signupResponse === void 0 ? void 0 : signupResponse.error_info) === null || _b === void 0 ? void 0 : _b.email) {
                        showToast({
                            message: "Email: ".concat((_c = signupResponse === null || signupResponse === void 0 ? void 0 : signupResponse.error_info) === null || _c === void 0 ? void 0 : _c.email),
                            status: 'error',
                        });
                    }
                    else {
                        showToast({
                            message: signupResponse.message,
                            status: 'error',
                        });
                    }
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fieldArray = (config === null || config === void 0 ? void 0 : config.dynamicFields) || [];
        var fileFields = fieldArray.filter(function (field) { return field.type === 'file'; });
        var nonFileFields = fieldArray.filter(function (field) { return field.type !== 'file'; });
        // If no file fields, don't update config
        if (fileFields.length === 0)
            return;
        var reorderedFields = __spreadArray(__spreadArray([], fileFields, true), nonFileFields, true);
        setConfig(__assign(__assign({}, config), { dynamicFields: reorderedFields }));
        setIsFileAvliable(true);
    }, []);
    useEffect(function () {
        var fieldArray = (config === null || config === void 0 ? void 0 : config.dynamicFields) || [];
        var fileField = fieldArray.filter(function (field) { return field.type === 'file'; });
        var fileObj = {};
        if (fileField.length > 0) {
            fileField.forEach(function (field) {
                fileObj[field.name] = null;
            });
            setFile(fileObj);
            setIsFileAvliable(true);
        }
    }, [config === null || config === void 0 ? void 0 : config.dynamicFields]);
    return (_jsxs(_Fragment, { children: [openVerifyEmailModal && (_jsx(VerifyEmailModal, { email: email, isOpen: openVerifyEmailModal, onClose: function () {
                    setOpenVerifyEmailModal(false);
                    onSuccess();
                }, onEmailVerify: onEmailVerify })), _jsxs("form", { onSubmit: handleSubmit(onSubmit), className: 'vas-w-full vas-flex vas-flex-col vas-gap-4', children: [(_d = (_c = config === null || config === void 0 ? void 0 : config.dynamicFields) === null || _c === void 0 ? void 0 : _c.filter(function (field) {
                        return !field.isDefault;
                    })) === null || _d === void 0 ? void 0 : _d.map(function (field) {
                        switch (field.type) {
                            case 'file':
                                return (_jsx(FileUploader, { files: file, setFiles: setFile, fileError: fileError, setFileError: setFileError, fileName: field.name }));
                            case 'dropdown':
                                return (_jsx("div", { className: 'vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight', children: _jsx(FormDropdown, __assign({ control: control, label: field.label, placeholder: field.placeholder || "Select Your ".concat(field.label), options: field.options || [], error: errors[field.name], required: field.required }, register(field.name, {
                                        required: "".concat(field.label, " is required"),
                                    }), { dataFromApi: field === null || field === void 0 ? void 0 : field.dataFromApi, apiEndpoint: field === null || field === void 0 ? void 0 : field.apiEndpoint })) }));
                            default:
                                return (_jsx(InputField, __assign({ label: field.label, placeholder: field.placeholder || "Enter Your ".concat(field.label), type: field.type, error: errors[field.name], required: field.required }, register(field.name, {
                                    required: field.required && "".concat(field.label, " is required"),
                                }), { inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg focus:vas-outline-none', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight' }), field.name));
                        }
                    }), _jsx(InputField, __assign({ type: 'password', placeholder: 'Enter your Password', label: 'Password', required: true }, register('password', {
                        required: 'Password required',
                        minLength: {
                            value: 8,
                            message: 'Password must have at least 8 characters',
                        },
                        pattern: {
                            value: /^(?=.*\d)(?=.*[\W_]).{8,}$/, // Regex for at least one uppercase letter and one number
                            message: 'Password must contain at least one special character and one digit',
                        },
                    }), { error: errors.password, inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg  focus:vas-outline-none', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight' })), _jsx(InputField, __assign({ type: 'password', placeholder: 'Enter your Confirm Password', label: 'Confirm Password', required: true }, register('confirmPassword', {
                        required: 'Confirm Password required',
                        validate: function (value) { return value === watch('password') || 'Passwords do not match'; },
                    }), { error: errors.confirmPassword, inputClass: 'vas-w-full vas-p-2 vas-border vas-rounded-lg focus:vas-outline-none', labelClass: 'vas-block vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight' })), _jsx("div", { className: 'vas-flex vas-items-center', children: _jsx(Checkbox, __assign({ id: 'rememberMe', label: 'Remember me on this computer' }, register('rememberMe'), { labelClass: "vas-ml-2 vas-text-vastypographyLabelsTextColor vas-text-vastypographyLabelsFontSize vas-font-vastypographyLabelsFontWeight", inputClass: 'vas-w-4 vas-h-4 vas-text-primary vas-border-vastypographyLabelsTextColor/30 vas-rounded vas-focus:ring-primary vas-accent-vasAccent' })) }), _jsx(Button, { isLoading: isLoading, type: 'submit', className: 'vas-w-full vas-text-white vas-py-2 vas-rounded-lg vas-text-vastypographyHeadingFontSize vas-font-vastypographyHeadingFontWeight vas-hover:bg-primary vas-shadow-md vas-shadow-primary/30 vas-bg-primary', children: "Sign Up" })] })] }));
};
export default SignupForm;
